/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementPreset} from '../models/EntitlementPreset';
import type {Error} from '../models/Error';

export interface GetAccountPreset$Request {
    accountId: number;
}

export interface GetAccountPreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountPresetRequest = createAction<PayloadData<void, GetAccountPreset$Request>>('ACCOUNT_PRESET__GET_ACCOUNT_PRESET__REQUEST');
export const getAccountPresetSuccess = createAction<PayloadData<EntitlementPreset, GetAccountPreset$Request>>('ACCOUNT_PRESET__GET_ACCOUNT_PRESET__SUCCESS');
export const getAccountPresetFailure = createAction<PayloadData<Error, GetAccountPreset$Request, true>>('ACCOUNT_PRESET__GET_ACCOUNT_PRESET__FAILURE');

export const getAccountPresetActions = [
    getAccountPresetRequest,
    getAccountPresetSuccess,
    getAccountPresetFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountPreset = (meta: GetAccountPreset$Request, config?: GetAccountPreset$Config) => {
    return {
        CALL_API: {
            types: getAccountPresetActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/presets`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAccountPreset$Request {
    accountId: number;
    presetId?: string;
}

export interface UpdateAccountPreset$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountPresetRequest = createAction<PayloadData<void, UpdateAccountPreset$Request>>('ACCOUNT_PRESET__UPDATE_ACCOUNT_PRESET__REQUEST');
export const updateAccountPresetSuccess = createAction<PayloadData<void, UpdateAccountPreset$Request>>('ACCOUNT_PRESET__UPDATE_ACCOUNT_PRESET__SUCCESS');
export const updateAccountPresetFailure = createAction<PayloadData<Error, UpdateAccountPreset$Request, true>>('ACCOUNT_PRESET__UPDATE_ACCOUNT_PRESET__FAILURE');

export const updateAccountPresetActions = [
    updateAccountPresetRequest,
    updateAccountPresetSuccess,
    updateAccountPresetFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} [meta.presetId]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountPreset = (meta: UpdateAccountPreset$Request, config?: UpdateAccountPreset$Config) => {
    const TRANSPORT_GET_PARAMS = {
        presetId: meta.presetId,
    };
    return {
        CALL_API: {
            types: updateAccountPresetActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/presets`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

